import { ButtonHTMLAttributes, forwardRef } from "react";
import { stringToColor } from "../../utils";

interface AvatarProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  characters: string;
  size?: "md" | "lg";
}

const sizeClasses = {
  md: "w-10 h-10 text-sm",
  lg: "w-20 h-20 text-2xl",
};

const Avatar = forwardRef<HTMLButtonElement, AvatarProps>(
  ({ characters, size = "md", className = "", ...rest }, ref) => {
    const bgColor = stringToColor(characters);

    return (
      <button
        ref={ref}
        type="button"
        className={`flex flex-col items-center space-y-1 focus:outline-none shadow-sm rounded-full ${className}`}
        {...rest}
      >
        <div
          className={`${sizeClasses[size]} rounded-full flex items-center justify-center text-white font-semibold`}
          style={{ backgroundColor: bgColor }}
        >
          {characters}
        </div>
      </button>
    );
  },
);

Avatar.displayName = "Avatar";

export default Avatar;
